import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { CreateApplicationPayload, RegisterCandidatePayload, CheckCandidateApplications } from '../models/candidate.model';
import { Pagination } from '../models/pagination.interface';
import { AUTH_TOKEN } from '../resources/auth-token';
import { CountryCallingCode } from '../models/country-calling-codes.model';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class CandidateRegisterService {

  applyingForUniversalJob: boolean;
  continuingApplication = false;

  private _callingCodes: CountryCallingCode[];

  constructor(
    private http: HttpClient,
    private configService: AppConfigService,
    protected toastr: ToastrService
  ) {}

  createApplication(registerCandidatePayload: RegisterCandidatePayload): Observable<{guid: string}> {
    const { inHouseQuestionSelectedAnswer, gender, universalJobId, additionalJobsToApplyTo, phone, name, email, picture, location } = registerCandidatePayload;

     const payload: CreateApplicationPayload = {
      //dateOfBirth always send as null, it's for security reasons, if someone sends a number, or without he will get false app guid
      dateOfBirth: null,
      candidatePhoneNumber: phone,
      candidateName: name,
      candidateEmail: email,
      inHouseQuestionSelectedAnswer: inHouseQuestionSelectedAnswer,
      additionalJobsToApply: [],
      picture,
      gender,
      location
    };

    if (universalJobId) {
      payload.universalJob = universalJobId;
    } else {
      payload.job = Number(sessionStorage.getItem('jobId'));
    }

    if (additionalJobsToApplyTo && additionalJobsToApplyTo.length) {
      payload.additionalJobsToApply = additionalJobsToApplyTo;
    }

    const referrer = this.configService.referrer;

    if (referrer) {
      payload.referer = referrer;
    }

    const universalJobsArray = this.configService.config.organization.universalJobs;
    const jobGuid = universalJobId ? universalJobsArray.length > 1
    ? this.getUniversalJobGuid(universalJobId) : universalJobsArray[0].guid : sessionStorage.getItem('jobGuid');

    const companyGuid = sessionStorage.getItem('companyGuid');

    return this.http.post<{guid: string}>(`${environment.api}/${companyGuid}/${jobGuid}/candidate-and-application`, payload);
  }

  getUniversalJobGuid(universalJobId: number): string {
    const universalJob = this.configService.config.organization.universalJobs.find(unJob => unJob.id === universalJobId);
    return universalJob.guid;
  }

  submitReferer(type: string, referer: string, entityGuid?: string): Observable<any> {

    const payload: {type: string, referer: string, entityGuid?: string} = {
      type,
      referer,
      entityGuid
    };

    return this.http.post(
      environment.referrer,
      payload,
      {
        headers: new HttpHeaders({ Authorization: AUTH_TOKEN }),
      }
    );

  }

  getRefererList(type: string, entityGuid?: string): Observable<any> {
    let params = new HttpParams();

    params = params.append('type', type);
    params = params.append('entityGuid', entityGuid);

    return this.http.get(
      environment.referrer,
      {
        headers: new HttpHeaders({ Authorization: AUTH_TOKEN }),
      }
    );
  }


  checkIfCandidateAlreadyApplied(candidateData: CheckCandidateApplications): Observable<{guid: string}> {
    return this.http.post<{guid: string}>(`${environment.api}/applications/guid`, candidateData);
  }

  getCountryCallingCodes(): Observable<CountryCallingCode[]> {
    const origin = window.location.origin;

    if (this._callingCodes) {
      return of(this._callingCodes);
    }

    return this.http.get<CountryCallingCode[]>(`${origin}/assets/country-calling-codes.json`)
      .pipe(
        tap((callingCodes: CountryCallingCode[]) => this._callingCodes = callingCodes)
      );
  }

  getLocations(country?: number): Observable<Location[]> {
    const countryId = country ? country : this.configService.organization.country.id;
    let params = new HttpParams();
    params = params.append('country', `${countryId}`);
    return this.http
      .get(`${environment.locations}?limit=1000`, { params }).pipe(
        map(({data}: Pagination<Location>) => data)
      )
  }
}
